<template>
  <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
    <!--begin::Toolbar-->
    <div class="toolbar" id="kt_toolbar">
      <!--begin::Container-->
      <app-sub-header :title="title" :breadcrumbs="breadcrumbs"></app-sub-header>
      <!--end::Container-->
    </div>
    <!--begin::Post-->
    <div v-show="isReady">
      <div class="post d-flex flex-column-fluid" id="kt_post">
        <div id="kt_content_container" class="container-xxl" style="margin-bottom: 50px!important;">
          <div class="card">
            <form @submit.prevent="updateBundleData">
              <div class="card-header flex-wrap border-0 pt-6 pb-0">
                <div class="card-title">
                  <h3 class="card-label">{{ $t(isCreate ? 'bundle.add' : 'bundle.update') }}</h3>
                </div>
                <div class="card-toolbar">
                  <button type="button" @click="$goTo('/admin/settings-product/bundles')" class="btn btn-sm btn-light fw-bolder">
                    {{$t("button.cancel")}}
                  </button>
                </div>
              </div>
              <div class="card-body">
                <div class="card-body pt-0">
                  <div class="row mb-5">
                    <div class="col-md-6 col-sm-12">
                      <div class="mb-3">
                        <label class="required form-label fs-6 fw-bolder text-black">{{ $t('bundle.title') }}</label>
                        <input type="text" v-model="formEditData.title" :placeholder="$t('bundle.placeholder_title')" required
                               class="form-control form-control-solid mb-2" />
                      </div>

                      <div class="mb-3">
                        <label class="form-label fs-6 fw-bolder text-black">{{ $t('bundle.apply') }}</label>
                        <select class="form-select form-select-solid kt_select2" data-control="select2" name="apply" v-model="formEditData.apply" :data-placeholder="$t('bundle.placeholder_apply')" data-allow-clear="true">
                          <option v-for="apply in AppliesData" :key="apply.value" :value="apply.value">{{ translateData(apply) }}</option>
                        </select>
                      </div>

                      <div class="mb-3" v-if="hasMultipleShops && appliesToPos">
                        <Select2
                            containerClass=""
                            name="bundleShops"
                            :label="$t('bundle.applicableShops')"
                            labelClass="form-label fs-6 fw-bolder text-black"
                            :multiple="true"
                            :selectClass="'form-select form-control-lg form-control-solid form-select-solid'"
                            :isRequired="true"
                            :placeholderText="$t('bundle.applicableShopsPlaceholder')"
                            v-model="formEditData.shops">
                          <option v-for="shop in societyShops" :key="shop.id" :value="shop.id">{{ shop.name }}</option>
                        </Select2>
                      </div>

                      <div class="mb-3 mt-5">
                        <div class="form-check form-check-custom form-check-solid form-check-sm">
                          <input class="form-check-input" type="checkbox" v-model="formEditData.online" id="flexRadioLg1"/>
                          <label class="form-check-label mr-4" style="margin-left: 10px !important;" for="flexRadioLg">
                            {{ $t('bundle.available') }}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-sm-12 mt-5">
                      <div class="">
                        <div style="text-align:center">
                          <ImageInput v-model:image="formEditData.file" image-class="w-150px h-150px mb-1" :current-image="formEditData.file_url" :default-image="defaultBundleImage" />
                        </div>
                      </div>


                    </div>
                  </div>

                  <br>
                  <div class="row mb-5">
                    <p class="mb-5">{{ $t('bundle.choice_products_text') }}</p>
                    <div class="scrollable-container">
                      <div class="row mb-3 align-items-center" v-for="row in productSaleElementPerProducts" :key="row._uid">
                        <div class="col-sm-8">
                          <select :data-row-uid="row._uid" class="form-select form-select-solid kt_select2 mb-2" data-control="select2"
                                  v-model="row.product_sale_element_id"
                                  :data-placeholder="$t('bundle.product_placeholder')" data-allow-clear="true">
                            <option></option>
                            <optgroup v-for="category in productSaleElementsByCategories.filter((c) => filterAvailableSaleElementsInCategory(c, row).length)" :key="category.category_id" :label="category.category_name">
                              <option v-for="saleElement in filterAvailableSaleElementsInCategory(category, row)" :key="saleElement.id" :value="saleElement.id">
                                {{ saleElement.name }}
                              </option>
                            </optgroup>
                          </select>
                        </div>
                        <div class="col-sm-3">
                          <input type="number" min="1" v-model.number="row.quantity" class="form-control form-control-solid mb-2"
                                 :class="{ 'is-invalid': rowExceedsStock(row) }" :placeholder="$t('bundle.quantity')" />
                          <div class="text-danger fs-8 mt-1" v-if="rowExceedsStock(row)">
                            {{ $t('bundle.quantity_exceeds_stock', { available: rowAvailableStock(row) }) }}
                          </div>
                        </div>
                        <div class="col-sm-1">
                          <button @click.prevent="removeProductRow(row._uid)" type="button" class="btn btn-sm btn-icon text-danger btn-active-color-danger">
                            <i class="la la-trash fs-2"></i>
                          </button>
                        </div>
                        <!-- Accompagnement / boisson du plat, fixés par le commerçant (inclus dans le pack) :
                             même liste (select2) que le choix du produit -->
                        <template v-if="rowOptionGroups(row).length">
                          <div class="col-sm-8 mb-2" v-for="group in rowOptionGroups(row)" :key="group.id">
                            <label class="form-label fs-7 fw-bold text-gray-700 mb-1" :class="{ required: group.min_choices > 0 }">{{ group.name }}</label>
                            <select class="form-select form-select-solid kt_select2_pack_option" data-control="select2" data-hide-search="true"
                                    :data-row-uid="row._uid" :data-group-id="group.id"
                                    :data-placeholder="group.min_choices > 0 ? $t('bundle.choose_option') : $t('bundle.no_option')"
                                    :data-allow-clear="group.min_choices > 0 ? 'false' : 'true'"
                                    :value="groupValue(row, group)">
                              <option></option>
                              <option v-for="item in group.items" :key="item.id" :value="item.id">{{ item.name }}</option>
                            </select>
                          </div>
                        </template>
                      </div>
                    </div>
                    <div class="d-flex justify-content-end">
                      <button @click.prevent="addProductRow" type="button" class="btn btn-sm btn-light-primary">
                        <i class="fa fa-plus"></i> {{ $t('bundle.add_product_row') }}
                      </button>
                    </div>
                  </div>

                  <div class="row mb-5" v-if="productSaleElementPerProducts.length > 0">
                      <div class="col-md-3 col-sm-12">
                        <label class="form-label fs-6 fw-bolder text-black">
                          <span class=""> {{ $t('bundle.subtotal') }}</span>
                        </label>
                        <div class="input-group mb-5">
                          <input type="text" readonly :value="bundlePrice" class="form-control-solid form-control mb-5"  />
                          <span style="height: 42px;" class="input-group-text" id=""> {{ currency ? currency : '' }} </span>
                        </div>
                      </div>

                      <div class="col-md-3 col-sm-12">
                        <div class="mb-3">
                          <label class="required form-label fs-6 fw-bolder text-black">
                            {{ $t('bundle.type_discount') }}
                          </label>
                          <select name="edit_type" required class="form-select form-select-solid kt_select2"
                                  v-model="formEditData.type" data-control="select2" data-search="true"
                                  :data-placeholder="$t('bundle.select_type')">
                            <option v-for="types in TypesData" :key="types.value" :value="types.value">{{ translateData(types) }}</option>
                          </select>
                        </div>
                      </div>

                      <div class="col-md-3 col-sm-12">
                        <label class="form-label fs-6 fw-bolder text-black">
                          <span class="required"> {{ formEditData.type === 'AMOUNT' ? $t('bundle.amount_discount') : $t('bundle.percent_discount') }}</span>
                        </label>
                        <div class="input-group mb-5">
                          <input type="number" min="0" v-model="formEditData.discount" class="form-control-solid form-control mb-5" required />
                          <span style="height: 42px;" class="input-group-text" id="basic-addon2"> {{ formEditData.type === 'AMOUNT' ? currency: '%' }} </span>
                        </div>
                      </div>

                      <div class="col-md-3 col-sm-12">
                        <label class="form-label fs-6 fw-bolder text-black">
                          <span class=""> {{ $t('bundle.bundle_price') }}</span>
                        </label>
                        <div class="input-group mb-5">
                          <input type="text" readonly :value="applyDiscount(bundlePrice, formEditData.type, formEditData.discount)" class="form-control-solid form-control mb-5"  />
                          <span style="height: 42px;" class="input-group-text" id=""> {{ currency ? currency : '' }} </span>
                        </div>
                      </div>
                  </div>

                  <div class="row mb-5">
                    <div class="col-12">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <label class="form-label mb-0" for="bundleDescription">{{ $t('bundle.description') }}</label>
                        <div class="d-flex align-items-center gap-2">
                          <select v-model="aiStyle" class="form-select form-select-sm form-select-solid py-1 fs-8 w-auto">
                            <option value="short">{{ $t('product.ai_style_short') }}</option>
                            <option value="medium">{{ $t('product.ai_style_medium') }}</option>
                            <option value="full">{{ $t('product.ai_style_full') }}</option>
                          </select>
                          <button type="button"
                                  class="btn btn-sm btn-light-primary py-1 px-3 fs-7"
                                  :disabled="isAiGenerating || !formEditData.title"
                                  :title="!formEditData.title ? $t('product.ai_name_required') : ''"
                                  @click.prevent="generateDescription">
                            <span v-if="isAiGenerating">
                              <span class="spinner-border spinner-border-sm me-1"></span>{{ $t('product.ai_generating') }}
                            </span>
                            <span v-else>
                              <i class="bi bi-stars me-1"></i>{{ $t('product.generate_with_ai') }}
                            </span>
                          </button>
                        </div>
                      </div>
                      <div ref="descriptionEditorContainer" class="form-control form-control-solid p-0" style="min-height: 150px; border: 1px solid #ddd;"></div>
                    </div>
                  </div>

                  <div class="text-muted fs-7 mt-3" v-if="bundleProductLength < 2">
                    {{ $t('bundle.min_products_hint') }}
                  </div>

                  <div class="row">
                    <div class="d-flex justify-content-end mt-10">
                      <button type="submit" class="btn btn-sm btn-primary fw-bolder" :disabled="isLoading || bundleProductLength < 2 || hasStockExceeded" style="margin-right: 10px;">
                        <span class="indicator-label">{{ $t('button.save') }}</span>
                        <span class="indicator-progress" v-show="isLoading">{{  $t('loading') }}
                            <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      </button>
                      <button type="button" @click="$goTo('/admin/settings-product/bundles')" class="btn btn-sm btn-light fw-bolder">
                        {{$t("button.cancel")}}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="container-xxl" v-show="!isReady">
      <div class="row loader text-center">
        <Loader />
      </div>
    </div>
  </div>
</template>

<script setup>
import { brandedPlaceholder } from '@/composables/useBranding'
import AppSubHeader from "@/views/Bundle/partials/AppSubHeaderView.vue";
import Loader from "@/components/Loader.vue";
import {ref, onMounted, onBeforeUnmount, computed, watch, nextTick, markRaw} from "vue";
import ImageInput from "@/components/ImageInput.vue";
import Select2 from "@/components/Select2.vue";
import {useStore} from "vuex";
import {useRoute} from "vue-router";
import {BASE_URL} from "@/services/api";
import i18n from '../../plugins/i18n'
import attributs from "@/store/modules/settings/attributs";
import router from "@/router";
import {formattedLocalAmount} from "@/mixins/Helper.vue";

const store = useStore()
const route = useRoute()

const isCreate = computed(() => !route.params.id)

// Image par défaut d'un pack : le même colis neutre que dans la liste des packs (servi par
// l'API). Dans le back-office il n'est jamais teinté à la couleur du client.
const defaultBundleImage = brandedPlaceholder('bundle')
const bundleId = ref(route.params.id || null)

const title = ref("breadcrumbs.bundle.bundles")
const breadcrumbs = ref([
  {
    name: 'breadcrumbs.store.dashboard',
    path: '/admin/dashboard'
  },
  {
    name: 'breadcrumbs.bundle.list',
    path: '/admin/settings-product/bundles'
  },
  {
    name: isCreate.value ? 'bundle.add' : 'breadcrumbs.bundle.update',
    path: isCreate.value ? '/admin/settings-product/bundles/create' : '/admin/settings-product/bundles/:id/edit'
  },
])

const formEditData = ref({
  id: bundleId.value,
  title: '',
  file : '',
  description : '',
  online : true,
  apply: [],
  type: "",
  discount: "",
  file_url: "",
  price: "",
  shops: [],
})

const isReady = ref(false)
const isLoading = ref(false)
const societyShops = computed(() => store.getters['society/getSocietyShops'])
const hasMultipleShops = computed(() => societyShops.value.length > 1)
// Le choix de la/les boutique(s) ne sert que pour le POS (une seule
// boutique = un seul site e-commerce, la question ne se pose pas là).
const appliesToPos = computed(() => formEditData.value.apply === 'POS')

const bundle = ref({})
const productSaleElementPerProducts = ref([])
const currency = ref('')
const AppliesData = computed(() => store.getters['bundle/getBundleApplyEnum'])
const TypesData = computed(() => store.getters['bundle/getBundleTypeEnum'])
// catégories sans article (catégories parentes notamment) retirées : elles apparaissaient vides en tête de liste
const productSaleElementsByCategories = computed(() => (store.getters['products/getProductSaleElementsByCategories'] || [])
  .filter((category) => (category.sale_elements || []).length > 0))

// Accompagnements / boissons de chaque plat du pack (module « Options & suppléments ») :
// le commerçant fixe le choix, inclus dans le prix du pack. Clé : id de la déclinaison.
const packOptionGroups = ref({})
const optionsModuleActive = computed(() => (store.getters['tenantModule/modules'] || []).includes('ecommerce.product_options'))
const rowOptionGroups = (row) => packOptionGroups.value[row.product_sale_element_id] || []
const groupValue = (row, group) => (row.optionIds || []).find((id) => group.items.some((item) => item.id === id)) || ''
function setGroupValue(row, group, value) {
  const groupItemIds = group.items.map((item) => item.id)
  row.optionIds = [...(row.optionIds || []).filter((id) => !groupItemIds.includes(id)), ...(value ? [value] : [])]
}
async function loadPackOptionGroups() {
  if (!optionsModuleActive.value) return
  const ids = productSaleElementPerProducts.value
    .map((row) => row.product_sale_element_id)
    .filter((id) => id && !(id in packOptionGroups.value))
  if (ids.length) {
    try {
      const response = await window.axios.get('get/product/option/groups/for/sale-elements', { params: { ids } })
      packOptionGroups.value = { ...packOptionGroups.value, ...(response.data.groups || {}) }
    } catch (e) {
      // sans les groupes, le pack s'enregistre sans choix fixés
    }
  }
  initPackOptionSelects()
}

// Listes accompagnement/boisson en select2, comme le choix du produit : initialisées une fois
// rendues, la valeur choisie est recopiée dans la ligne (v-model ne capte pas select2)
function initPackOptionSelects() {
  nextTick(() => {
    const $selects = $("select.kt_select2_pack_option:not(.select2-hidden-accessible)")
    $selects.each(function () {
      const row = productSaleElementPerProducts.value.find((r) => r._uid === Number($(this).attr('data-row-uid')))
      const group = row && rowOptionGroups(row).find((g) => g.id === $(this).attr('data-group-id'))
      $(this).select2({ minimumResultsForSearch: Infinity, allowClear: $(this).attr('data-allow-clear') === 'true' })
      if (row && group) $(this).val(groupValue(row, group) || null).trigger('change.select2')
    })
    $selects.on('change', function () {
      const row = productSaleElementPerProducts.value.find((r) => r._uid === Number($(this).attr('data-row-uid')))
      const group = row && rowOptionGroups(row).find((g) => g.id === $(this).attr('data-group-id'))
      if (row && group) setGroupValue(row, group, this.value || '')
    })
  })
}

const allSaleElementsFlat = computed(() => {
  const flat = []
  productSaleElementsByCategories.value.forEach((category) => {
    (category.sale_elements || []).forEach((saleElement) => flat.push(saleElement))
  })
  return flat
})

const allSaleElementsById = computed(() => {
  const flat = {}
  allSaleElementsFlat.value.forEach((saleElement) => {
    flat[saleElement.id] = saleElement
  })
  return flat
})

const bundlePrice = computed(() => {
  return productSaleElementPerProducts.value.reduce((acc, row) => {
    const saleElement = allSaleElementsById.value[row.product_sale_element_id]
    return acc + ((saleElement?.price || 0) * (row.quantity || 0))
  }, 0)
})

const bundleProductLength = computed(() => {
  return productSaleElementPerProducts.value.reduce((acc, row) => acc += (row.quantity || 0), 0);
});

const applyDiscount = (amount = 0, discountType = 'PERCENT', discountValue = '') => {
  if(amount <= 0 ) return 0

  if(discountType == 'PERCENT') {
    const discount = discountValue < 0 ? 0 : discountValue >= 100 ? 100 : discountValue
    return amount - (amount * discount / 100)
  }

  const discount = amount - discountValue
  return discount >= 0 ? discount : 0
}

watch(() => formEditData.value.apply, () => {
  // Le champ "Boutiques concernées" ne s'affiche que si le canal choisi
  // inclut le POS (voir appliesToPos) — s'il se cache suite à un changement
  // de canal, on vide la sélection pour éviter d'envoyer une sélection
  // obsolète, invisible à l'écran, au moment d'enregistrer.
  if (!appliesToPos.value) {
    formEditData.value.shops = []
  }
  nextTick(() => {
    initSelect2()
  })
})

watch(() => formEditData.value.type, () => {
  nextTick(() => {
    initSelect2()
  })
})

// Le bloc remise (Type de remise…) n'apparaît qu'avec le premier produit : son
// select n'existait pas lors de l'initialisation de la page, il faut l'habiller
// de select2 à son apparition (sinon style natif jusqu'à la prochaine réinit).
watch(() => productSaleElementPerProducts.value.length > 0, (visible) => {
  if (!visible) return
  nextTick(() => {
    const $type = $('select[name="edit_type"]:not(.select2-hidden-accessible)')
    if (!$type.length) return
    $type.select2()
    $type.on('change', function () {
      formEditData.value.type = this.value
    })
  })
})

// N'initialise select2 sur les lignes produit qu'une fois les catégories
// chargées (sinon le <select> se retrouve initialisé sans options, et les
// options ajoutées ensuite par Vue ne sont jamais reprises par select2).
// Le garde-fou :not(.select2-hidden-accessible) rend l'appel idempotent :
// il ne touche que les lignes pas encore initialisées, jamais les autres.
watch(
  () => [productSaleElementsByCategories.value.length, productSaleElementPerProducts.value.length],
  ([categoriesCount, rowsCount]) => {
    if (categoriesCount > 0 && rowsCount > 0) {
      nextTick(() => {
        const $newRowSelects = $("select[data-row-uid].kt_select2:not(.select2-hidden-accessible)")
        $newRowSelects.select2()
        // v-model seul ne suffit pas toujours à capter la sélection faite via
        // le widget select2 (comme pour apply/edit_type plus haut) : on
        // écrit explicitement la valeur dans la ligne correspondante.
        $newRowSelects.on('change', function () {
          const uid = Number($(this).attr('data-row-uid'))
          const row = productSaleElementPerProducts.value.find((r) => r._uid === uid)
          if (row) {
            row.product_sale_element_id = this.value
          }
        })
      })
    }
  }
)

const descriptionEditorContainer = ref(null)
const aiStyle = ref('medium')
const isAiGenerating = ref(false)
let descriptionEditor = null

async function initDescriptionEditor() {
  await nextTick()
  if (!descriptionEditor && window.ClassicEditor && descriptionEditorContainer.value) {
    const editor = await window.ClassicEditor.create(descriptionEditorContainer.value, {
      toolbar: [
        "heading", "|", "bold", "italic", "link", "bulletedList", "numberedList",
        "|", "blockQuote", "insertTable", "undo", "redo"
      ]
    })
    descriptionEditor = markRaw(editor)
    descriptionEditor.setData(formEditData.value.description || '')
    descriptionEditor.model.document.on("change:data", () => {
      formEditData.value.description = descriptionEditor.getData()
    })
  } else if (descriptionEditor) {
    descriptionEditor.setData(formEditData.value.description || '')
  }
}

async function generateDescription() {
  if (!formEditData.value.title) {
    window.toastr['warning'](i18n.global.t('product.ai_name_required'))
    return
  }
  isAiGenerating.value = true
  try {
    const attrs = productSaleElementPerProducts.value
      .filter((row) => row.product_sale_element_id)
      .map((row) => {
        const saleElement = allSaleElementsById.value[row.product_sale_element_id]
        return { attribute: i18n.global.t('bundle.product_name'), value: (saleElement?.name || '') + ' x' + row.quantity }
      })

    const price = applyDiscount(bundlePrice.value, formEditData.value.type, formEditData.value.discount)

    const response = await store.dispatch('products/generateProductDescription', {
      name: formEditData.value.title,
      category: '',
      price: price || null,
      attributes: attrs,
      style: aiStyle.value,
    })

    if (descriptionEditor) {
      descriptionEditor.setData(response.data.description)
      formEditData.value.description = response.data.description
    }
    if (response.data.slogan) {
      window.toastr['success'](`${i18n.global.t('product.ai_description_inserted')} — "${response.data.slogan}"`)
    } else {
      window.toastr['success'](i18n.global.t('product.ai_description_inserted'))
    }
  } catch (e) {
    window.toastr['error'](e?.response?.data?.message || i18n.global.t('product.ai_error'))
  } finally {
    isAiGenerating.value = false
  }
}

onBeforeUnmount(() => {
  if (descriptionEditor) {
    descriptionEditor.destroy()
    descriptionEditor = null
  }
})

// accompagnements/boissons chargés pour chaque plat ajouté ou changé dans le pack
watch(
  [() => productSaleElementPerProducts.value.map((row) => row.product_sale_element_id).join(','), optionsModuleActive],
  () => loadPackOptionGroups(),
  { immediate: true }
)

onMounted(() => {
  isReady.value = false
  reloadData()
  store.dispatch('products/loadAllProductSaleByCategories')
  if (!isCreate.value) {
    getBundleData()
  }
  initSelect2()
  initDescriptionEditor()
  store.dispatch('shop/getCurrency').then(response => {
    currency.value = response?.data.currency_symbol ? response?.data.currency_symbol : response?.data.symbol_native
  })
  store.dispatch('society/fetchSociety')
})

let rowUidCounter = 0

function addProductRow() {
  productSaleElementPerProducts.value.push({ _uid: ++rowUidCounter, product_sale_element_id: '', quantity: 1 })
}

function removeProductRow(uid) {
  productSaleElementPerProducts.value = productSaleElementPerProducts.value.filter((row) => row._uid !== uid)
}

function filterAvailableSaleElementsInCategory(category, row) {
  return (category.sale_elements || []).filter((saleElement) =>
      saleElement.id === row.product_sale_element_id ||
      !productSaleElementPerProducts.value.some((otherRow) => otherRow !== row && otherRow.product_sale_element_id === saleElement.id)
  )
}

function rowAvailableStock(row) {
  const saleElement = allSaleElementsById.value[row.product_sale_element_id]
  return saleElement?.available_stock ?? null
}

function rowExceedsStock(row) {
  const availableStock = rowAvailableStock(row)
  // null = stock non géré (Niveau 1) : pas de limite.
  return availableStock !== null && Number(row.quantity) > availableStock
}

const hasStockExceeded = computed(() => {
  return productSaleElementPerProducts.value.some((row) => rowExceedsStock(row))
})

async function updateBundleData(){
  isLoading.value = true
  // options fixées : seulement celles des groupes du plat choisi (une ligne qui change de plat perd les anciennes)
  let data = productSaleElementPerProducts.value.filter((row) => row.product_sale_element_id).map((row) => ({
    ...row,
    options: (row.optionIds || []).filter((id) => rowOptionGroups(row).some((group) => group.items.some((item) => item.id === id))),
  }))
  formEditData.value.price = applyDiscount(bundlePrice.value, formEditData.value.type, formEditData.value.discount)

  try {
    if (isCreate.value) {
      const createRes = await store.dispatch('bundle/createBundle', formEditData.value)
      bundleId.value = createRes.data.data.id
      formEditData.value.id = bundleId.value
    }

    await Promise.all([
      store.dispatch('bundle/storeOrUpdateBundleProducts', { id: bundleId.value, products: data }),
      store.dispatch('bundle/updateBundle', formEditData.value)
    ]);

    window.toastr['success'](i18n.global.t(isCreate.value ? 'notification.bundle_created' : 'notification.bundle_updated'));

    isLoading.value = false;
    router.push({ name: 'bundles-path' })
  } catch (error) {
    isLoading.value = false;
  }

}

function initSelect2(){
  KTApp.initSelect2()
  $(".kt_select2").select2()

  $(".kt_select2").change((e) => {
    switch (e.target.name) {
      case 'apply':
        formEditData.value.apply = e.target.value
        break;
      case 'edit_type':
        formEditData.value.type = e.target.value
        break;
      default:
        break;
    }
  });
}

function reloadData(){
  store.dispatch('bundle/loadBundleApplyEnum')
  store.dispatch('bundle/loadBundleTypeEnum').then(() => {
    isReady.value = true
  })
}

function getBundleData(){
  try{
    store.dispatch('bundle/showBundle', route.params.id).then((response) =>{
      let data = response.data?.data
      bundle.value = data

      formEditData.value.title = bundle.value?.title
      formEditData.value.description = bundle.value?.description || ''
      initDescriptionEditor()
      formEditData.value.online = bundle.value?.online
      formEditData.value.discount = bundle.value?.discount
      formEditData.value.type = bundle.value?.type
      formEditData.value.apply = bundle.value?.apply
      formEditData.value.file_url = bundle.value?.file_url
      formEditData.value.price = bundle.value?.price - bundle.value?.price_offset
      formEditData.value.shops = (bundle.value?.bundleShops || []).map((bundleShop) => bundleShop.shop?.id).filter(Boolean)

      productSaleElementPerProducts.value = (bundle.value?.bundleProducts || []).map((bundleProduct) => ({
        _uid: ++rowUidCounter,
        product_sale_element_id: bundleProduct.product_sale_element_id,
        quantity: bundleProduct.quantity,
        optionIds: (bundleProduct.options || []).map((option) => option.id),
      }))
    })
  }catch(err){
    window.toastr['error'](err.message)
  }
}

function translateData(element){
  return (i18n.locale == 'en') ? element.en : element.fr
}

</script>

<style scoped>
.badge {
  display: none !important;
  align-items: center;
}

.badge-light-danger {
  color: #f1416c;
  background-color: #fff5f8;
  padding: 15px !important;
  text-align: center !important;
}

.scrollable-container {
  max-height: 400px;
  overflow-y: auto;
}

th {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 1;
}
</style>
